// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__2cRB1","more":"styles_more__1Zh6K"};